import { useState } from "preact/hooks"

export default function Select({ value, onChange, options, label, activeString }) {
    const [active, setActive] = useState(false)

    return (
        <div class="ns-relative">
            <div class={`ns-sort-background ns-d-none ${active ? 'ns-sort-active' : ''}`} onClick={() => setActive(!active)}></div>
            <div className="ns-relative ns-sort-toggle" onClick={() => setActive(!active)}>
                <span>{activeString}</span>
                <span class="ns-sort-arrow">
                    <svg width="14px" height="14px" aria-hidden="true" focusable="false" class="arrow" style="color:black" data-prefix="fas" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
                    </svg>
                </span>
            </div>
            <div
                className={`${active ? 'ns-d-flex ns-flex-column' : 'ns-d-none'} ns-sort-wrapper ns-absolute`}
                value={value}
                aria-label={label || "Select"}
            >
                <div class="ns-sort-option ns-sort-header ns-d-md-none ns-relative">
                    <span>SORT BY</span>
                    <span class="ns-sort-close" onClick={() => setActive(!active)}>
                        <svg width="20px" height="20px" fill="black" color="black" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                            <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
                        </svg>
                    </span>
                </div>
                {options.map(option => (
                    <span class={`ns-sort-option ${value == option.value ? 'ns-sort-selected' : ''}`} key={option.value} sort-value={option.value} onClick={onChange}>
                        {option.label}
                    </span>
                ))}
            </div>
        </div>
    )
}
